import React from 'react';
import {useDispatch} from 'react-redux';
import {removeModal} from '../store/app';
import Modal from '../components/Modal';
import Button from '../components/Button';
import t from 'babel-plugin-yate/macro';

export default function CancelTransactionModal({modalId, cancelHandler}) {
  const dispatch = useDispatch();

  const closeCancelModalHandler = () => {
    dispatch(removeModal(modalId));
  };

  return (
    <Modal
      id={modalId}
      header={t`Cancel transaction`}
      width="md:w-2/3 lg:w-2/5 lg:max-w-sm">
      <div className="my-8 mx-4 flex justify-center flex-col">
        <div className="mb-4 text-center">{t`Confirm cancel transaction message`}</div>

        <div className="flex justify-center">
          <div className="mr-4">
            <Button
              title={t`Discard`}
              border={true}
              onClick={closeCancelModalHandler}
            />
          </div>

          <Button
            title={t`Confirm cancel`}
            color="red"
            border={true}
            onClick={cancelHandler}
          />
        </div>
      </div>
    </Modal>
  );
}
